import { render, staticRenderFns } from "./orderCont.vue?vue&type=template&id=ffa79f44&scoped=true"
import script from "./orderCont.vue?vue&type=script&lang=js"
export * from "./orderCont.vue?vue&type=script&lang=js"
import style0 from "./orderCont.vue?vue&type=style&index=0&id=ffa79f44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa79f44",
  null
  
)

export default component.exports